const toNumber = (value, fallback) => {
    const parsed = Number(value);
    return Number.isFinite(parsed) && parsed > 0 ? parsed : fallback;
};

export const API_URL = process.env.REACT_APP_API_URL || '';

export const WS_LOGS_URL = process.env.REACT_APP_WS_LOGS_URL || 'wss://scraplands.ru:4083';
export const WS_CHAT_URL = process.env.REACT_APP_WS_CHAT_URL || 'wss://scraplands.ru:4093';

export const WS_RECONNECT_INITIAL_DELAY = toNumber(
    process.env.REACT_APP_WS_RECONNECT_INITIAL_DELAY,
    1000
);

export const WS_RECONNECT_MAX_DELAY = toNumber(
    process.env.REACT_APP_WS_RECONNECT_MAX_DELAY,
    30000
);

export const WS_RECONNECT_MAX_ATTEMPTS = toNumber(
    process.env.REACT_APP_WS_RECONNECT_MAX_ATTEMPTS,
    20
);
